/**
 * Quyền nền tảng của tính năng module (ADR-0104). Không thuộc module nào nên mang tiền tố `core` — mã module không
 * được đặt, nên không đụng quyền của module bên thứ ba. Quản trị tổ chức có sẵn cả ba; người khác được gán qua vai trò
 * ở màn Vai trò & phân quyền, nhóm "Quản lý module".
 */
export const QUYEN_MODULE = {
  /** Xem danh sách module đã duyệt và trạng thái cài. */
  xem: 'core:module:read',
  /** Nộp gói và xem các gói mình đã nộp. */
  nop: 'core:module:submit',
  /** Cài, nâng cấp, quay lại, gỡ module; gồm cả quyền xem. */
  cai: 'core:module:install',
} as const;
